import { Pipe, Input, NgModule } from '@angular/core';
import { config, MemberQuery } from '@fgb/core';
import { DomSanitizer } from '@angular/platform-browser';
import { marked } from 'marked';
import { formatNumber, CurrencyPipe } from '@angular/common';
import { isObservable, of } from 'rxjs';
import { map, startWith, catchError } from 'rxjs/operators';
import * as _moment from 'moment';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/platform-browser';
import * as ɵngcc3 from '@angular/common';
class ContentImagePipe {
    constructor(memberQuery) {
        this.memberQuery = memberQuery;
    }
    transform(value, variantId, loyaltyType) {
        if (!value) {
            if (!loyaltyType) {
                return `${config.contentUrl}/images/noimage.png`;
            }
            else {
                switch (loyaltyType) {
                    case 'marketplace': {
                        return 'assets/images/placeholders/marketplace-item.png';
                    }
                    case 'auction': {
                        return 'assets/images/placeholders/auction-item.png';
                    }
                    case 'lotto': {
                        return 'assets/images/placeholders/lotto-item.png';
                    }
                    case 'wallet': {
                        return 'assets/images/placeholders/marketplace-item.png';
                    }
                    case 'badge': {
                        return 'assets/images/placeholders/badge-item.png';
                    }
                    default: {
                        return 'assets/images/placeholders/marketplace-item.svg';
                    }
                }
            }
        }
        else {
            let currentUser = this.memberQuery.getValue().user || { clubId: config.defaultClubId, lcid: config.defaultLcid };
            const imageName = value.substring(0, value.indexOf('.'));
            const fileExtension = value.substring(value.indexOf('.'));
            return `${config.contentUrl}/image/${imageName}__${currentUser.clubId}_${variantId}_${currentUser.lcid}${fileExtension}`;
        }
    }
}
ContentImagePipe.ɵfac = function ContentImagePipe_Factory(t) { return new (t || ContentImagePipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MemberQuery)); };
ContentImagePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "contentImage", type: ContentImagePipe, pure: true });
ContentImagePipe.ctorParameters = () => [
    { type: MemberQuery }
];
ContentImagePipe.propDecorators = {
    loyaltyType: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContentImagePipe, [{
        type: Pipe,
        args: [{ name: 'contentImage' }]
    }], function () { return [{ type: ɵngcc1.MemberQuery }]; }, { loyaltyType: [{
            type: Input
        }] }); })();

class SafeHtmlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(htmlText) {
        return this.sanitizer.bypassSecurityTrustHtml(htmlText);
    }
}
SafeHtmlPipe.ɵfac = function SafeHtmlPipe_Factory(t) { return new (t || SafeHtmlPipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.DomSanitizer)); };
SafeHtmlPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "safeHtml", type: SafeHtmlPipe, pure: true });
SafeHtmlPipe.ctorParameters = () => [
    { type: DomSanitizer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SafeHtmlPipe, [{
        type: Pipe,
        args: [{ name: 'safeHtml' }]
    }], function () { return [{ type: ɵngcc2.DomSanitizer }]; }, null); })();

class CreditCardNumberPipe {
    constructor() { }
    transform(value) {
        if (typeof value === 'string') {
            let cardNumber = value.replace(' ', '').replace('-', '');
            if (cardNumber.length === 16) {
                return '**** **** **** ' + value.substr(12);
            }
        }
        return value;
    }
}
CreditCardNumberPipe.ɵfac = function CreditCardNumberPipe_Factory(t) { return new (t || CreditCardNumberPipe)(); };
CreditCardNumberPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "creditCardNumber", type: CreditCardNumberPipe, pure: true });
CreditCardNumberPipe.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CreditCardNumberPipe, [{
        type: Pipe,
        args: [{ name: 'creditCardNumber' }]
    }], function () { return []; }, null); })();

class CardTypeImageUrlPipe {
    constructor() { }
    transform(value) {
        return config.contentUrl + `/images/providers/cardType/${value}.svg`;
    }
}
CardTypeImageUrlPipe.ɵfac = function CardTypeImageUrlPipe_Factory(t) { return new (t || CardTypeImageUrlPipe)(); };
CardTypeImageUrlPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cardTypeImageUrl", type: CardTypeImageUrlPipe, pure: true });
CardTypeImageUrlPipe.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardTypeImageUrlPipe, [{
        type: Pipe,
        args: [{ name: 'cardTypeImageUrl' }]
    }], function () { return []; }, null); })();

/**
 * This pipe is used to transform
 * markdown string to html.
 * To markdown translated text to html
 * you must have the translate and markdownTranslate
 * pipe in the correct order, as shown in
 * the example below. This will then apply the
 * markdown pipe to the translated text.
 *
 * Example of usage:
 * [innerHTML]="'registration.success.text' | translate | markdownTranslate"
 */
class MarkdownTranslatePipe {
    transform(value) {
        if (value && value.length > 0) {
            return marked(value);
        }
        return value;
    }
}
MarkdownTranslatePipe.ɵfac = function MarkdownTranslatePipe_Factory(t) { return new (t || MarkdownTranslatePipe)(); };
MarkdownTranslatePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "markdownTranslate", type: MarkdownTranslatePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarkdownTranslatePipe, [{
        type: Pipe,
        args: [{
                name: 'markdownTranslate'
            }]
    }], null, null); })();

class FortressCurrencyPipe {
    constructor(currencyPipe) {
        this.currencyPipe = currencyPipe;
    }
    transform(value, currencyCode, display, digitsInfo, locale) {
        if (currencyCode && currencyCode === 'PTS') {
            value = formatNumber(value, 'en-GB', '1.0-0');
            return value + ' Pts';
        }
        else {
            return this.currencyPipe.transform(value, currencyCode, display, digitsInfo, locale);
        }
    }
}
FortressCurrencyPipe.ɵfac = function FortressCurrencyPipe_Factory(t) { return new (t || FortressCurrencyPipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.CurrencyPipe)); };
FortressCurrencyPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "FortressCurrencyPipe", type: FortressCurrencyPipe, pure: true });
FortressCurrencyPipe.ctorParameters = () => [
    { type: CurrencyPipe }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FortressCurrencyPipe, [{
        type: Pipe,
        args: [{ name: 'FortressCurrencyPipe' }]
    }], function () { return [{ type: ɵngcc3.CurrencyPipe }]; }, null); })();

const defaultError = 'Something went wrong';
class WithLoadingPipe {
    transform(val) {
        return isObservable(val)
            ? val.pipe(map((value) => {
                return {
                    isLoading: (value === null || value === void 0 ? void 0 : value.type) === 'start',
                    error: (value === null || value === void 0 ? void 0 : value.type) === 'error' ? defaultError : '',
                    data: (value === null || value === void 0 ? void 0 : value.type) ? value.data : value,
                    isEmpty: !value,
                };
            }), startWith({ isLoading: true }), catchError((error) => of({ isLoading: false, error: typeof error === 'string' ? error : defaultError })))
            : val;
    }
}
WithLoadingPipe.ɵfac = function WithLoadingPipe_Factory(t) { return new (t || WithLoadingPipe)(); };
WithLoadingPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "withLoading", type: WithLoadingPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WithLoadingPipe, [{
        type: Pipe,
        args: [{ name: 'withLoading' }]
    }], null, null); })();

/**
 * This pipe is used to transform
 * the long text into short text.
 * it will take the numeric value as limit and then add (...) after the text
 *
 * Example of usage:
 * <p> {{ 'Hello world' | shortText: 5}} </p>"
 * Result Hello...
 */
class LongtoShortTextPipe {
    transform(value, limit) {
        return value.length > limit ? value.substring(0, limit) + '...' : value;
    }
}
LongtoShortTextPipe.ɵfac = function LongtoShortTextPipe_Factory(t) { return new (t || LongtoShortTextPipe)(); };
LongtoShortTextPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "shortText", type: LongtoShortTextPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LongtoShortTextPipe, [{
        type: Pipe,
        args: [{
                name: 'shortText'
            }]
    }], null, null); })();

/**
 * This pipe is used to get the content by lcid
 * it will take the list of content and lcid and return
 * the contact that match the lcid otherwise return the
 * firts one
 * Example of usage:
 * <p> {{  let content of offerContentList | currentLanguageContent: 2057}} </p>"
 */
class ContentLanguageFilterPipe {
    transform(contents, lcid, callFor) {
        callFor = callFor.toLowerCase();
        if (!contents)
            return 'n/a';
        if (!(contents === null || contents === void 0 ? void 0 : contents.some((x) => x.LCID == +lcid))) {
            return callFor == 'name' ? contents[0].Name : callFor == 'description' ? contents[0].Description : 'n/a';
        }
        let langContent = contents === null || contents === void 0 ? void 0 : contents.filter((content) => {
            return content.LCID == +lcid;
        });
        if (langContent)
            return callFor == 'name' ? langContent[0].Name : callFor == 'description' ? langContent[0].Description : 'n/a';
        return 'n/a';
    }
}
ContentLanguageFilterPipe.ɵfac = function ContentLanguageFilterPipe_Factory(t) { return new (t || ContentLanguageFilterPipe)(); };
ContentLanguageFilterPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "currentLanguageContent", type: ContentLanguageFilterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContentLanguageFilterPipe, [{
        type: Pipe,
        args: [{
                name: 'currentLanguageContent'
            }]
    }], null, null); })();

const moment = _moment;
class UtcToLocaltimePipe {
    transform(value, format = 'MMMM D, YYYY hh:mm a') {
        if (value) {
            return moment.utc(value).local().format(format);
        }
        return value;
    }
}
UtcToLocaltimePipe.ɵfac = function UtcToLocaltimePipe_Factory(t) { return new (t || UtcToLocaltimePipe)(); };
UtcToLocaltimePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "UtcToLocaltimePipe", type: UtcToLocaltimePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UtcToLocaltimePipe, [{
        type: Pipe,
        args: [{ name: 'UtcToLocaltimePipe' }]
    }], null, null); })();

class PipesModule {
}
PipesModule.ɵfac = function PipesModule_Factory(t) { return new (t || PipesModule)(); };
PipesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PipesModule });
PipesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PipesModule, { declarations: [ContentImagePipe, SafeHtmlPipe, CardTypeImageUrlPipe, CreditCardNumberPipe, MarkdownTranslatePipe, FortressCurrencyPipe, WithLoadingPipe, LongtoShortTextPipe, ContentLanguageFilterPipe, UtcToLocaltimePipe], exports: [ContentImagePipe, SafeHtmlPipe, CardTypeImageUrlPipe, CreditCardNumberPipe, MarkdownTranslatePipe, FortressCurrencyPipe, WithLoadingPipe, LongtoShortTextPipe, ContentLanguageFilterPipe, UtcToLocaltimePipe] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PipesModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ContentImagePipe,
                    SafeHtmlPipe,
                    CardTypeImageUrlPipe,
                    CreditCardNumberPipe,
                    MarkdownTranslatePipe,
                    FortressCurrencyPipe,
                    WithLoadingPipe,
                    LongtoShortTextPipe,
                    ContentLanguageFilterPipe,
                    UtcToLocaltimePipe
                ],
                exports: [
                    ContentImagePipe,
                    SafeHtmlPipe,
                    CardTypeImageUrlPipe,
                    CreditCardNumberPipe,
                    MarkdownTranslatePipe,
                    FortressCurrencyPipe,
                    WithLoadingPipe,
                    LongtoShortTextPipe,
                    ContentLanguageFilterPipe,
                    UtcToLocaltimePipe
                ],
                imports: []
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CardTypeImageUrlPipe, ContentImagePipe, ContentLanguageFilterPipe, CreditCardNumberPipe, FortressCurrencyPipe, LongtoShortTextPipe, MarkdownTranslatePipe, PipesModule, SafeHtmlPipe, UtcToLocaltimePipe, WithLoadingPipe };

//# sourceMappingURL=fgb-portal-component-library-src-lib-pipes.js.map